import {createSmartAction} from 'redux-smart-actions';

export const postPasswordReset = createSmartAction(({email, onSuccess} = {}) => ({
  request: {
    url: '/mco-leclub-api/v1/password/reset-request',
    method: 'post',
    data: {email},
  },
  meta: {
    onSuccess: response => {
      if (onSuccess) onSuccess();
      return response;
    },
  },
}));
